import React from 'react';

const StatisticsEffectBg = ({ children, waveSize = 'large' }) => {

  return (
    <section className="relative bg-[#28357B] overflow-hidden">
      <div className="absolute inset-0">
        {/* Back layer */}
            <div className={`absolute bottom-0 left-0 right-0 ${waveSize === 'large' ? 'h-90vh' : 'h-90vh'} bg-white bg-opacity-5`}
             style={{
               clipPath: 'polygon(0 100%, 0 60%, 15% 55%, 30% 65%, 45% 50%, 60% 60%, 75% 45%, 90% 55%, 100% 50%, 100% 100%)'
             }}>
        </div>
        
        {/* Middle layer */}
        <div className={`absolute bottom-0 left-0 right-0 ${waveSize === 'large' ? 'h-80vh' : 'h-60vh'} bg-white bg-opacity-5`}
             style={{
               clipPath: 'polygon(0 100%, 0 70%, 20% 60%, 35% 70%, 50% 55%, 65% 65%, 80% 50%, 95% 60%, 100% 65%, 100% 100%)'
             }}>
        </div>
        
        {/* Front layer */}
        <div className={`absolute bottom-0 left-0 right-0 ${waveSize === 'large' ? 'h-70vh' : 'h-50vh'} bg-white bg-opacity-5`}
             style={{
               clipPath: 'polygon(0 100%, 0 80%, 25% 70%, 40% 75%, 55% 65%, 70% 70%, 85% 60%, 100% 70%, 100% 100%)'
             }}>
        </div>
      </div>
          
      
      <div className="relative z-10">
        {children}
      </div>
    </section>
  );
};

export default StatisticsEffectBg;
